import { Img } from "onnit-ui/lib/image";
import MediaContentShowcase from "onnit-ui/lib/module/MediaContentShowcase";
import React from "react";
import useOnnitContext from "onnit-ui/lib/hooks/useOnnitContext";
import greensBlend from "./greensBlend";
import usePageData from "../../hooks/usePageData";

export default function () {
    const onnitContext = useOnnitContext();
    const { pageData } = usePageData();

    if (!pageData || !onnitContext) return null;

    const IMG_URL = `${onnitContext.url.cdn.static_images}/product-page/${pageData.slug}/ingredients`;
    const IMG_PNG_PARAMS = '?q=40&auto=compress,format';
    return (
        <MediaContentShowcase
            mt={[6, 6, 8]}
            mb={[6]}
            items={greensBlend.map((x) => {
                let copy = { ...x };
                copy.image = `${IMG_URL}/${copy.image}${IMG_PNG_PARAMS}`;
                return copy;
            })}
            activeColor="#FDDA71"
            textColor="white"
            bgMedia={
                <Img
                    alt="Fresh vegetables on Farm."
                    placeholder={[754, 208]}
                    src={`${IMG_URL}/Ingredients-BG-Banner.png${IMG_PNG_PARAMS}`}
                />
            }
        />
    );
}
